import mainBgImage from 'assets/bg/main-bg.svg';
import flyWebp from 'assets/images/fly.webp';

// UI Icons
import backIcon from 'assets/icons/back.svg';
import infoIcon from 'assets/icons/info.svg';
import withdrawIcon from 'assets/icons/withdraw.svg';
import bakingCubeIcon from 'assets/icons/baking-cube.svg';
import cartIcon from 'assets/icons/cart.svg';
import unbakingCubeIcon from 'assets/icons/unbaking-cube.svg';
import inInventoryIcon from 'assets/icons/in_inventory.svg';

// Header icons
import leftRect2 from 'assets/header/left-rect-2.svg';
import leftRect1 from 'assets/header/left-rect-1.svg';
import rightRect1 from 'assets/header/right-rect-1.svg';
import rightRect2 from 'assets/header/right-rect-2.svg';

// Images
import keyImage from 'assets/images/key.png';
import rocketImage from 'assets/images/rocket.webp';
import qrCodeImage from 'assets/images/qr-code.png';
import ovensImage from 'assets/images/ovens.webp';
import botsImage from 'assets/images/bots.webp';
import chestsImage from 'assets/images/chests.webp';
import ovenCapacityGift from 'assets/images/oven-capacity-gift.webp';
import exchangeIcon from 'assets/images/exchange.png';
import threeDonutsImage from 'assets/images/three-donuts.png';
import turboSpeedBtnImage from 'assets/images/turbo-speed-btn.webp';
import plusBuyImage from 'assets/images/plus-buy.png';

// Onboarding
import arrowImage from 'assets/onboarding/arrow.png';
import bulbImage from 'assets/onboarding/bulb.png';

// Blue donuts
import blueDonut19 from 'assets/donuts/blue-donut-19.webp';
import blueDonut24 from 'assets/donuts/blue-donut-24.webp';
import blueDonut29 from 'assets/donuts/blue-donut-29.webp';
import blueDonut34 from 'assets/donuts/blue-donut-34.webp';
import blueDonut39 from 'assets/donuts/blue-donut-39.webp';
import blueDonut44 from 'assets/donuts/blue-donut-44.webp';
import blueDonut49 from 'assets/donuts/blue-donut-49.webp';
import blueDonut54 from 'assets/donuts/blue-donut-54.webp';
import blueDonut59 from 'assets/donuts/blue-donut-59.webp';
import blueDonut64 from 'assets/donuts/blue-donut-64.webp';

// Green donuts
import greenDonut19 from 'assets/donuts/green-donut-19.webp';
import greenDonut24 from 'assets/donuts/green-donut-24.webp';
import greenDonut29 from 'assets/donuts/green-donut-29.webp';
import greenDonut34 from 'assets/donuts/green-donut-34.webp';
import greenDonut39 from 'assets/donuts/green-donut-39.webp';
import greenDonut44 from 'assets/donuts/green-donut-44.webp';
import greenDonut49 from 'assets/donuts/green-donut-49.webp';
import greenDonut54 from 'assets/donuts/green-donut-54.webp';
import greenDonut59 from 'assets/donuts/green-donut-59.webp';
import greenDonut64 from 'assets/donuts/green-donut-64.webp';

// Pink donuts
import pinkDonut19 from 'assets/donuts/pink-donut-19.webp';
import pinkDonut24 from 'assets/donuts/pink-donut-24.webp';
import pinkDonut29 from 'assets/donuts/pink-donut-29.webp';
import pinkDonut34 from 'assets/donuts/pink-donut-34.webp';
import pinkDonut39 from 'assets/donuts/pink-donut-39.webp';
import pinkDonut44 from 'assets/donuts/pink-donut-44.webp';
import pinkDonut49 from 'assets/donuts/pink-donut-49.webp';
import pinkDonut54 from 'assets/donuts/pink-donut-54.webp';
import pinkDonut59 from 'assets/donuts/pink-donut-59.webp';
import pinkDonut64 from 'assets/donuts/pink-donut-64.webp';

// Purple donuts
import purpleDonut19 from 'assets/donuts/purple-donut-19.webp';
import purpleDonut24 from 'assets/donuts/purple-donut-24.webp';
import purpleDonut29 from 'assets/donuts/purple-donut-29.webp';
import purpleDonut34 from 'assets/donuts/purple-donut-34.webp';
import purpleDonut39 from 'assets/donuts/purple-donut-39.webp';
import purpleDonut44 from 'assets/donuts/purple-donut-44.webp';
import purpleDonut49 from 'assets/donuts/purple-donut-49.webp';
import purpleDonut54 from 'assets/donuts/purple-donut-54.webp';
import purpleDonut59 from 'assets/donuts/purple-donut-59.webp';
import purpleDonut64 from 'assets/donuts/purple-donut-64.webp';

// Yellow donuts
import yellowDonut19 from 'assets/donuts/yellow-donut-19.webp';
import yellowDonut24 from 'assets/donuts/yellow-donut-24.webp';
import yellowDonut29 from 'assets/donuts/yellow-donut-29.webp';
import yellowDonut34 from 'assets/donuts/yellow-donut-34.webp';
import yellowDonut39 from 'assets/donuts/yellow-donut-39.webp';
import yellowDonut44 from 'assets/donuts/yellow-donut-44.webp';
import yellowDonut49 from 'assets/donuts/yellow-donut-49.webp';
import yellowDonut54 from 'assets/donuts/yellow-donut-54.webp';
import yellowDonut59 from 'assets/donuts/yellow-donut-59.webp';
import yellowDonut64 from 'assets/donuts/yellow-donut-64.webp';

// Token icons
import bobeCoin from 'assets/icons/tokens/bobe-coin.webp';
import donCoin from 'assets/icons/tokens/don-coin.webp';
import energyCharge from 'assets/icons/tokens/energy-charge.webp';
import usdt from 'assets/icons/usdt.webp';
import ton from 'assets/icons/ton.png';
import stars from 'assets/icons/star.svg';

// Token icons
export const TOKEN_ICONS = {
  bobeCoin,
  donCoin,
  energyCharge,
  usdt,
  ton,
  stars,
} as const;

// Booster icons
import boosterInsects from 'assets/icons/boosters/1.webp';
import boosterDon from 'assets/icons/boosters/2.webp';
import boosterDuration from 'assets/icons/boosters/3.webp';
import boosterDailyLimit from 'assets/icons/boosters/4.webp';
import boosterEnergyRecharge from 'assets/icons/boosters/5.webp';
import boosterSkipWaiting from 'assets/icons/boosters/6.webp';

// Booster button images
import boosterBoostButton from 'assets/icons/boosters/boost-button.webp';
import boosterTimerButton from 'assets/icons/boosters/timer-button.webp';

export const COMMON_PRELOAD_ASSETS = {
  appBgImage: mainBgImage,
  bobeHero: '/bobe-hero.webp',
  bobeHero2: '/bobe-hero_market.webp',
  bobeBakery: 'bobe-hero_bak.webp',
  userAvatar: '/bobe-avatar-placeholder.webp',
  fly: flyWebp,
} as const;

export const BOOSTER_ICONS: Record<string, string> = {
  booster_insects_x: boosterInsects,
  booster_don_x: boosterDon,
  booster_duration_x: boosterDuration,
  booster_daily_bonus_limit_plus: boosterDailyLimit,
  booster_energy_recharge: boosterEnergyRecharge,
  booster_skip_waiting: boosterSkipWaiting,
} as const;

export const BOOSTER_BUTTONS = {
  boost: boosterBoostButton,
  timer: boosterTimerButton,
} as const;

// Donut types
export type DonutColor = 'blue' | 'green' | 'pink' | 'purple' | 'yellow';
export type DonutSize = 19 | 24 | 29 | 34 | 39 | 44 | 49 | 54 | 59 | 64;

// Map for easy access
export const DONUT_IMAGES: Record<DonutColor, Record<DonutSize, string>> = {
  blue: {
    19: blueDonut19,
    24: blueDonut24,
    29: blueDonut29,
    34: blueDonut34,
    39: blueDonut39,
    44: blueDonut44,
    49: blueDonut49,
    54: blueDonut54,
    59: blueDonut59,
    64: blueDonut64,
  },
  green: {
    19: greenDonut19,
    24: greenDonut24,
    29: greenDonut29,
    34: greenDonut34,
    39: greenDonut39,
    44: greenDonut44,
    49: greenDonut49,
    54: greenDonut54,
    59: greenDonut59,
    64: greenDonut64,
  },
  pink: {
    19: pinkDonut19,
    24: pinkDonut24,
    29: pinkDonut29,
    34: pinkDonut34,
    39: pinkDonut39,
    44: pinkDonut44,
    49: pinkDonut49,
    54: pinkDonut54,
    59: pinkDonut59,
    64: pinkDonut64,
  },
  purple: {
    19: purpleDonut19,
    24: purpleDonut24,
    29: purpleDonut29,
    34: purpleDonut34,
    39: purpleDonut39,
    44: purpleDonut44,
    49: purpleDonut49,
    54: purpleDonut54,
    59: purpleDonut59,
    64: purpleDonut64,
  },
  yellow: {
    19: yellowDonut19,
    24: yellowDonut24,
    29: yellowDonut29,
    34: yellowDonut34,
    39: yellowDonut39,
    44: yellowDonut44,
    49: yellowDonut49,
    54: yellowDonut54,
    59: yellowDonut59,
    64: yellowDonut64,
  },
};

// Get donut image by color and size
export function getDonutImage(color: DonutColor, size: DonutSize): string {
  return DONUT_IMAGES[color][size];
}

// All donuts for preloading
export const PRELOAD_DONUTS = Object.values(DONUT_IMAGES).flatMap((colorGroup) =>
  Object.values(colorGroup),
);

// UI Icons export
export const UI_ICONS = {
  backIcon,
  infoIcon,
  withdrawIcon,
  bakingCubeIcon,
  cartIcon,
  unbakingCubeIcon,
  inInventoryIcon,
} as const;

// Header icons export
export const HEADER_ICONS = {
  leftRect2,
  leftRect1,
  rightRect1,
  rightRect2,
} as const;

// Other images export
export const OTHER_IMAGES = {
  keyImage,
  rocketImage,
  qrCodeImage,
  arrowImage,
  bulbImage,
  ovensImage,
  botsImage,
  chestsImage,
  ovenCapacityGift,
  exchangeIcon,
  threeDonutsImage,
  turboSpeedBtnImage,
  plusBuyImage,
} as const;

// All assets for preloading
export const ALL_PRELOAD_ASSETS = [
  ...Object.values(COMMON_PRELOAD_ASSETS),
  ...Object.values(TOKEN_ICONS),
  ...Object.values(BOOSTER_ICONS),
  ...Object.values(BOOSTER_BUTTONS),
  ...Object.values(UI_ICONS),
  ...Object.values(HEADER_ICONS),
  ...Object.values(OTHER_IMAGES),
  ...PRELOAD_DONUTS,
];
